import { getAxiosConfig, getDomainOrigin } from 'utils/serverConfig';
import axios from 'axios';

export const getDealerDashboard = async (
    partnerId: string,
    groupName: string,
    page: number,
    tab?: string,
    journey?: string
) => {
    try {
        const { status, data } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/dealer-dashboard?group_name=${groupName}`,
            params: {
                page,
                status: tab,
                journey,
            },
            ...getAxiosConfig(),
        });
        if (status === 200 && data) {
            return {
                data,
                status: true,
            };
        }
        return {
            status: false,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        return {
            status: false,
        };
    }
};
